import React from "react";
import URL from "../../../../constant/URL";
import {withRouter} from "react-router-dom";

const LearningNoteLevel = withRouter((props) => {

  const [levelList, setLevelList] = React.useState([]);
  // const [levelFlag, setLevelFlag] = React.useState(false);

  const moveLevel = () => {
    if(document.getElementById('on')){
      document.getElementById('on').scrollIntoView({inline : 'center', behavior: 'smooth'});
    }
  };

  const onChangeClass = (e, index) => {
    e.stopPropagation();
    let list = [...levelList];
    for(let i=0; i<list.length; i++){
      if(i === index){
        list[i].on = 'on';
      }else{
        list[i].on = '';
      }
    }
    setLevelList(list);
    props.onChangeLevel(list[index].levelCode);
    props.history.replace(`${URL.COURSE_LEARNING.LEARNING_NOTE}/${list[index].levelCode}`);
  };

  const level = () => {

   return (
     levelList.map((item, index) => (
       <li className={item.on === 'on' ? 'on' : index} id={item.on === 'on' ? 'on' : index} key={index}><button type="button" onClick={(e)=>onChangeClass(e, index)}>{item.level}</button></li>
      ))
   );
  };

  const changeLevelList = () => {
    if(props.levelList){
      let list = [];
      for(let i=0; i<props.levelList.length; i++){
        list.push({level : `LV ${props.levelList[i]?.lvlTxt}`, on : props.id === props.levelList[i].lvlCd ? 'on' : '', levelCode : props.levelList[i].lvlCd,});
      }

      if(!props.id && props.levelList.length){
        list[props.levelList.length-1].on = 'on';
      }
      setLevelList(list);
    }
  };

  React.useEffect(changeLevelList, [props.levelList] );
  React.useEffect(moveLevel, [levelList] );

  return (
    <div className="lev_boxes">
      <ul className="cls">
        {level()}
      </ul>
    </div>
  );

});

export default LearningNoteLevel;



